import { API } from 'utils/api.config';

export async function getAllUpComingApi(page) {
  return await API.get(`api/upcoming?page=${page}`);
}
